export default __webpack_public_path__ + "static/media/insta.75e0546a.png";